var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutlookCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7988 4.4248H18.9442C19.3424 4.4248 19.6655 4.74783 19.6655 5.14608V14.5202C19.6655 14.9184 19.3424 15.2414 18.9442 15.2414H11.7988V4.4248Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6821 6.86279H11.7988V14.5042H18.6821V6.86279Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3083 19.6666L0 17.4541V2.21249L11.3083 0V19.6666Z",
    fill: "#1976D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53215 6.146C3.97062 6.146 2.70508 7.79701 2.70508 9.83348C2.70508 11.87 3.97062 13.521 5.53215 13.521C7.09368 13.521 8.35922 11.87 8.35922 9.83348C8.35922 7.79701 7.09368 6.146 5.53215 6.146ZM5.40923 12.046C4.59455 12.046 3.93424 11.0553 3.93424 9.83348C3.93424 8.61169 4.59455 7.62099 5.40923 7.62099C6.22392 7.62099 6.88423 8.61169 6.88423 9.83348C6.88423 11.0553 6.22392 12.046 5.40923 12.046Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1498 12.6543H11.8223V14.0801H13.1498V12.6543Z",
    fill: "#1976D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8236 12.6543H13.4961V14.0801H14.8236V12.6543Z",
    fill: "#1976D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4955 12.6543H15.168V14.0801H16.4955V12.6543Z",
    fill: "#1976D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1498 10.895H11.8223V12.3208H13.1498V10.895Z",
    fill: "#1976D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8236 10.895H13.4961V12.3208H14.8236V10.895Z",
    fill: "#1976D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4955 10.895H15.168V12.3208H16.4955V10.895Z",
    fill: "#1976D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1673 10.895H16.8398V12.3208H18.1673V10.895Z",
    fill: "#1976D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1498 9.19727H11.8223V10.6231H13.1498V9.19727Z",
    fill: "#1976D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8236 9.19727H13.4961V10.6231H14.8236V9.19727Z",
    fill: "#1976D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4955 9.19727H15.168V10.6231H16.4955V9.19727Z",
    fill: "#1976D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1673 9.19727H16.8398V10.6231H18.1673V9.19727Z",
    fill: "#1976D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8236 7.43018H13.4961V8.856H14.8236V7.43018Z",
    fill: "#1976D2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4955 7.43018H15.168V8.856H16.4955V7.43018Z",
    fill: "#1976D2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1673 7.43018H16.8398V8.856H18.1673V7.43018Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookCalendar);
export default __webpack_public_path__ + "static/media/outlook-calendar.3558d2e8c8ddc6d56785f5b5017d4f19.svg";
export { ForwardRef as ReactComponent };